/** Dashboard labels. SES itself stores only BOUNCE or COMPLAINT; the specific reason lives here. */
export const SUPPRESSION_REASON_LABELS = {
    complaint: "Reported as spam",
    hard_bounce: "Hard bounce",
    soft_bounce_repeat: "Repeated soft bounce (3 in 30 days)",
    dead_domain: "Domain can't receive mail",
    unsubscribe: "Unsubscribed",
    manual: "Manual",
};
const NOT_SUPPRESSED = { suppressed: false };
/**
 * Given every suppression row for one address, decide whether a message on `stream` for
 * `appId` / `listId` may be sent. Pure; `rows` is the full `SUPPRESS#<email>` partition.
 *
 * `listId` is optional: pass it only for a stream that belongs to a named list. `appId` is
 * always required so an `APP#` block for a different app is correctly ignored.
 */
export function isSuppressed(rows, appId, listId, stream) {
    // GLOBAL first, and it wins over everything including transactional.
    const global = rows.find((r) => r.scope === "GLOBAL");
    if (global) {
        return { suppressed: true, scope: "GLOBAL", reason: global.reason };
    }
    // Transactional mail bypasses APP/LIST blocks (but never GLOBAL, handled above).
    if (stream === "transactional") {
        return NOT_SUPPRESSED;
    }
    const appBlock = rows.find((r) => r.scope === "APP" && r.appId === appId);
    if (appBlock) {
        return { suppressed: true, scope: "APP", reason: appBlock.reason };
    }
    if (listId !== undefined) {
        const listBlock = rows.find((r) => r.scope === "LIST" && r.listId === listId);
        if (listBlock) {
            return { suppressed: true, scope: "LIST", reason: listBlock.reason };
        }
    }
    return NOT_SUPPRESSED;
}
/** Builds the SK for a suppression row from its scope. */
export function suppressionSk(scope, key) {
    switch (scope) {
        case "GLOBAL":
            return "GLOBAL";
        case "APP":
            if (!key?.appId)
                throw new Error("APP suppression row needs an appId.");
            return `APP#${key.appId}`;
        case "LIST":
            if (!key?.listId)
                throw new Error("LIST suppression row needs a listId.");
            return `LIST#${key.listId}`;
    }
}
/** Parses a suppression-row SK back into its scope and key parts. */
export function parseSuppressionSk(sk) {
    if (sk === "GLOBAL")
        return { scope: "GLOBAL" };
    if (sk.startsWith("APP#"))
        return { scope: "APP", appId: sk.slice("APP#".length) };
    if (sk.startsWith("LIST#"))
        return { scope: "LIST", listId: sk.slice("LIST#".length) };
    throw new Error(`Unrecognized suppression SK: ${sk}`);
}
